export const COLORS = [
  '#0F0C0C',
  '#F0F1F4',
  '#FF5F00',
  '#4F97FC',
  '#FF93D3',
  '#00DF00',
  '#FFCA00',
  '#79747E',
  '#138A1E',
  '#B01919',
  '#C70568',
  '#F9C87D',
  '#FCE3BE',
  '#FFFFFF',
  '#000000',
];
